import _ from 'lodash'

export function getCompanyContext() {
    const companyContext = _.get(process.env, 'VUE_APP_COMPANY_CONTEXT', null)

    if (companyContext === null) {
        throw new Error('unable to find company context')
    }

    return companyContext
}